import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { TPVServices } from '../../../tpv/services';
import { PrintServices } from '../../../services/printServices';


@Component({
  selector: 'page-configuration-printers-sunmi',
  templateUrl: 'configuration-printers-sunmi.html'
})

export class ConfigurationPrintersSunmiPage {


  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public tpvServices: TPVServices,
    private printServices: PrintServices) {
      if (!this.globals.restaurant.printer_size) {
        this.globals.restaurant.printer_size = '80';
      }
  }

  testPrint() {
    this.printServices.testSunmiPrint();
  }

  testOpenCashDrawer() {
    this.printServices.openCashDrawerSM();
  }

  async updateIonToggle(printer_cashdrawer) {
    this.globals.restaurant.printer_cashdrawer = printer_cashdrawer;
    this.tpvServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'printer_cashdrawer': printer_cashdrawer,
    });
  }

  async setPaperSize(size) {
    this.tpvServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'printer_size': size,
    }).then(() => {
      this.globals.restaurant.printer_size = size;
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-thermal-printers/configuration-printers-sunmi/configuration-printers-sunmi.ts